import { AfterContentInit, Component, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NgClass } from '@angular/common';
import { EmployeeApiService } from '../../../../../_services/employee-service/api/employee-api.service';
import { Employee, EmployeeRoleType, IdNumType } from '../../../../../_interfaces/employee.interface';
import { LoaderComponent } from '../../../../../shared/components/loader/loader.component';
import { OffcanvasService } from '../../../../../_services/offcanvas-service/offcanvas.service';
import { FormDirectivesService } from '../../../../../shared/directives/dynamic-form-directive/form-directives.service';
import { ToastService } from '../../../../../_services/toast-service/toast.service';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { EmptyIndicatorPipe } from '../../../../../shared/pipes/empty-indicator.pipe';
import { AppSelectors } from '../../../../../store/app/app.selectors';
import { AvatarComponent } from '../../../../../shared/components/avatar/avatar.component';
import { EmployeeService } from '../../../../../_services/employee-service/employee.service';
import { OffcanvasBaseComponent } from '../../../../../shared/components/offcanvas/offcanvas-base/offcanvas-base.component';

@Component({
  selector: 'app-view-employee-details',
  imports: [LoaderComponent, NgClass, EmptyIndicatorPipe, NgbTooltip, AvatarComponent, OffcanvasBaseComponent],
  templateUrl: './view-employee-details.component.html',
})
export class ViewEmployeeDetailsComponent implements AfterContentInit, OnDestroy {
  readonly store = inject(Store);
  readonly route = inject(ActivatedRoute);
  readonly employeeApiService = inject(EmployeeApiService);
  readonly employeeService = inject(EmployeeService);
  readonly offcanvasService = inject(OffcanvasService);
  readonly maskService = inject(FormDirectivesService);
  readonly toastService = inject(ToastService);

  readonly userProfile$ = this.store.select(AppSelectors.userDetails);
  protected readonly EmployeeRoleType = EmployeeRoleType;

  readonly subscriptions = new Subscription();

  protected userProfileEmail!: string;
  public employeeId!: string;
  public employee?: Employee;
  public returnUrl: string = '/employees';
  protected readonly IdNumType = IdNumType;

  constructor() {
    this.route.params.subscribe({
      next: (params: Params) => {
        this.employeeId = params['id'];
      },
    });
  }

  ngAfterContentInit(): void {
    this.subscriptions.add(
      this.userProfile$.subscribe((profile) => {
        if (profile) {
          this.userProfileEmail = profile.email;
        }
      }),
    );
    this.loadEmployeeDetails();
  }

  onEditEmployee() {
    this.employeeService.onEditEmployee(this.employeeId);
  }

  loadEmployeeDetails() {
    this.subscriptions.add(
      this.employeeApiService.getEmployeeById(this.employeeId).subscribe({
        next: (employee: Employee) => {
          this.employee = employee;
        },
        error: (error) => {
          if (error.error?.detail) {
            this.toastService.show(`${error.error.detail}`);
          }
        },
      }),
    );
  }

  onRemoveEmployee(employee: Employee) {
    this.offcanvasService.close(this.returnUrl);
    this.employeeService.onRemoveEmployee(employee);
    return false;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
